import { render, staticRenderFns } from "./imgUploader.vue?vue&type=template&id=71b3e952&scoped=true&"
import script from "./imgUploader.vue?vue&type=script&lang=js&"
export * from "./imgUploader.vue?vue&type=script&lang=js&"
import style0 from "./imgUploader.vue?vue&type=style&index=0&id=71b3e952&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71b3e952",
  null
  
)

export default component.exports